var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"layout-fade"}},[_c('v-layout',{attrs:{"wrap":""}},[_c('Navigation'),_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }